<template>
  <v-card>
    <v-card-title>
      <h2 style="text-align: center; font-size: 1rem">Pilih Bulan & Tahun Laporan</h2>
    </v-card-title>

    <v-container>
      <InputCoaWithoutChild
        itemValue="kode"
        :itemText="itemTextFn"
        v-model="subBukuBesar.from"
        label="Dari Kode Perkiraan"
      />
      <InputCoaWithoutChild
        itemValue="kode"
        :itemText="itemTextFn"
        v-model="subBukuBesar.to"
        label="Sampai Kode Perkiraan"
      />
    </v-container>

    <v-row justify="center">
      <v-date-picker v-model="periode" type="month" />
    </v-row>

    <v-card-actions>
      <v-spacer />
      <v-btn color="error" variant="text" @click="onclose"> Batal </v-btn>
      <v-btn
        color="primary"
        variant="text"
        @click="
          () => {
            onclose();
            generateSubBukuBesar();
          }
        "
      >
        Generate Laporan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '@/libs/axios';

import InputCoaWithoutChild from './InputCoaWithoutChild.vue';
export default {
  name: 'ModalContentSubBukuBesarBulan',
  components: {
    InputCoaWithoutChild,
  },
  data() {
    return {
      kodePerkiraanSelect: [],
      periode: '',
      subBukuBesar: {
        from: '',
        to: '',
      },
    };
  },
  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    let period = this.$getSelectedMonthYear();
    this.periode = period.dateTime;

    this.loadKodePerkiraanItem();
  },
  methods: {
    async loadKodePerkiraanItem() {
      try {
        let datas = await axios.get('/kodePerkiraanItem');

        for (const element of datas.data.data) {
          this.kodePerkiraanSelect.push({
            text: `${element.kode} - ${element.uraian}`,
            value: element.kode,
          });
        }
      } catch (err) {
        this.$toast.error(err);
      }
    },
    generateSubBukuBesar() {
      if (this.subBukuBesar.from == '' || this.subBukuBesar.to == '') {
        this.$toast.error('Silakan isi kode perkiraan terlebih dahulu');
        return;
      }

      this.$router.push(
        `/laporan/gl/subBukuBesar?periode=${this.periode}&from=${this.subBukuBesar.from}&to=${this.subBukuBesar.to}`
      );
    },
    itemTextFn(item) {
      return `${item.kode} - ${item.nama}`;
    },
  },
};
</script>
